<template>
  <div>
    <!--
    <div>2[{{ field.origin }}]</div>
    <div v-if="club && club.search">3[{{ club.search[field.origin] }}]</div>
    <div>4[{{ item }}]</div>
    -->
    <template v-if="loadings.club">
      {{ $t('general.loading') }}...
    </template>
    <template v-else-if="dbErrors.club">
      {{ dbErrors.club }}
    </template>
    <template v-else>
      <v-autocomplete
        v-validate="field.validation" 
        v-model="componentValue"
        :name="field.name"
        :items="itemOptions"
        :label="$t(`entity.${entity}.${field.name}.label`)"
        :error="hasError(field.name)"
        :error-messages="getError(field.name)"
        :prepend-icon="field.icon"
        :disabled="item && !field.allowEdit" 
        item-text="text"
        item-value="id"
        append-icon="add"
        @click:append="dialog = !dialog" />
      <v-dialog 
        v-model="dialog"
        :overlay="false"
        fullscreen
        transition="dialog-bottom-transition"
        content-class="custom-dialog"
        scrollable>
        <v-card>
          <v-toolbar 
            card 
            dark 
            color="primary">
            <v-btn 
              icon 
              dark
              @click.native="dialog = false" >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t(`entity.${entity}.search.${field.origin}.title`) }}</v-toolbar-title>
            <v-spacer/>
            <v-toolbar-items>
              <v-btn 
                dark 
                flat 
                @click.native="dialog = false">
                {{ $t('general.close') }}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-layout 
                v-for="option in formOptions(field.origin)"
                :key="option.code">
                <v-text-field 
                  :label="$t(`entity.${entity}.search.${option.label}.label`) " 
                  :placeholder="$t(`entity.${entity}.search.${option.label}.placeHolder`) " 
                  v-model="dialogValue[option.code]"/>
              </v-layout>
            </v-container>
            <v-layout >
              <v-spacer/>
              <v-btn 
                flat 
                @click.native="cleanForm">{{ $t('general.cancel') }}</v-btn>
              <v-btn 
                :disabled="!dialogValue.id"
                flat 
                @click.native="saveDialog(true)">{{ $t('general.duplicate') }}</v-btn>
              <v-btn 
                flat 
                class="primary"
                @click.native="saveDialog(false)">
                <template v-if="dialogValue.id">
                  {{ $t('general.update') }}
                </template>
                <template v-else>
                  {{ $t('general.add') }}
                </template>
              </v-btn>
            </v-layout>
            <v-layout 
              row
              mt-3>
              <table class="dialogTabe">
                <thead>
                  <tr>
                    <th
                      v-for="data in formOptions(field.origin)"
                      :key="data.code">
                      {{ $t(`entity.${entity}.search.${data.label}.label`) }}
                    </th>
                    <th>{{ $t('general.delete') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="option in itemOptions"
                    :key="option.id">
                    <td
                      v-for="data in formOptions(field.origin)"
                      :key="data.code"
                      @click.prevent="selectSuggestion(option)">
                      {{ cropText(option[data.code]) }}
                    </td>
                    <td>
                      <v-icon @click.prevent="deleteSuggestion(option)">delete_forever</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import bus from '@/components/Base/bus'
import ClubsLib from '@/lib/data/clubs'
const debug = require('debug')('OD::BaseFormSelectClub')

export default {
  name: 'BaseFormSelectClub',
  props: {
    entity: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      dialogValue: {},
      componentValue: '',
      club: {},
      loadings: {
        club: true,
      },
      dbErrors: {
        club: null,
      },
    }
  },
  computed: {
    itemOptions() {
      if (this.club && this.club.search && this.club.search[this.field.origin]) {
        return this.club.search[this.field.origin].map(item => {
          if (typeof item === 'object') {
            return item
          } else {
            return { id: item, text: item }
          }
        })
      }
      return []
    },
    clubId() {
      return this.item ? this.item.clubId : this.$route.params.clubId
    },
  },
  watch: {
    componentValue() {
      debug('componentValue', this.componentValue)
      this.$emit('update:value', this.componentValue)
    },
    clubId() {
      this.bind()
    },
  },
  created() {
    debug('created')
    this.init()
  },
  mounted() {
    bus.$on('validate', this.onValidate)
    this.bind()
  },
  beforeDestroy() {
    bus.$off('validate', this.onValidate)
  },
  methods: {
    cropText(text) {
      const num = 50
      const numCrop = 20
      if (text && text.length > num) {
        return text.substring(0, numCrop) + '...'
      }
      return text
    },
    init() {
      this.initForm()
      this.componentValue = this.item ? this.item[this.field.name] : null
    },
    initForm() {
      const options = this.formOptions(this.field.origin)
      options.forEach(option => {
        Vue.set(this.dialogValue, option.code, '')
      })
    },
    bind() {
      ClubsLib.bindItem(this, { clubId: this.clubId })
    },
    hasError(key) {
      return !!this.errors.first(key)
    },
    getError(key) {
      return this.errors.first(key) ? [this.errors.first(key)] : []
    },
    onValidate() {
      this.$validator.validateAll()
    },
    saveDialog(duplicate) {
      if (Object.keys(this.dialogValue).length > 0) {
        ClubsLib.addSuggestion(this, {
          clubId: this.clubId,
          data: this.dialogValue,
          key: this.field.origin,
          duplicate: duplicate,
        })
        this.initForm()
        // this.dialog = false
      }
    },
    selectSuggestion(option) {
      debug('selectSuggestion', option)
      if (typeof option === 'object') {
        const optionAux = Object.assign({}, option)
        // delete optionAux.id
        this.dialogValue = optionAux
      } else {
        this.dialogValue = { text: option }
      }
    },
    cleanForm() {
      this.dialogValue = {}
    },
    deleteSuggestion(option) {
      ClubsLib.deleteSuggestion(this, {
        clubId: this.clubId,
        item: option,
        key: this.field.origin,
      })
    },
    formOptions(option) {
      switch (option) {
        case 'categories':
          return [
            {
              label: 'categories',
              code: 'text',
            },
          ]
        case 'teams':
          return [
            {
              label: 'teams',
              code: 'text',
            },
            {
              label: 'logo',
              code: 'logo',
            },
          ]
        case 'locations':
          return [
            {
              label: 'locations',
              code: 'text',
            },
            {
              label: 'mapLink',
              code: 'mapLink',
            },
          ]
        default:
          return [
            {
              label: option,
              code: 'text',
            },
          ]
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-dialog,
.dialog__content {
  z-index: 1001 !important;
}
table.dialogTabe {
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
  }
  tbody {
    tr:nth-child(odd) {
      background: #f9f9f9;
    }
  }
}
</style>
